import { Run, RunState } from "types/generated";

// Check if the user can discard the run based on the run
export const isRunDiscardable = (run: Run): boolean =>
  run.state === RunState.Ready ||
  run.state === RunState.Queued ||
  run.state === RunState.Unconfirmed;
